module.exports = __webpack_public_path__ + "static/media/19_A.bf0ba817.png";